// Area units data for conversion routes
export const areaUnits = [
  { id: 'sqmeter', name: 'Square Meter', symbol: 'm²', plural: 'Square Meters', factor: 1 },
  { id: 'sqkilometer', name: 'Square Kilometer', symbol: 'km²', plural: 'Square Kilometers', factor: 1000000 },
  { id: 'sqcentimeter', name: 'Square Centimeter', symbol: 'cm²', plural: 'Square Centimeters', factor: 0.0001 },
  { id: 'sqmillimeter', name: 'Square Millimeter', symbol: 'mm²', plural: 'Square Millimeters', factor: 0.000001 },
  { id: 'sqmile', name: 'Square Mile', symbol: 'mi²', plural: 'Square Miles', factor: 2589988.110336 },
  { id: 'sqyard', name: 'Square Yard', symbol: 'yd²', plural: 'Square Yards', factor: 0.83612736 },
  { id: 'sqfoot', name: 'Square Foot', symbol: 'ft²', plural: 'Square Feet', factor: 0.09290304 },
  { id: 'sqinch', name: 'Square Inch', symbol: 'in²', plural: 'Square Inches', factor: 0.00064516 },
  { id: 'hectare', name: 'Hectare', symbol: 'ha', plural: 'Hectares', factor: 10000 },
  { id: 'acre', name: 'Acre', symbol: 'ac', plural: 'Acres', factor: 4046.8564224 },
];

// Popular conversions matching common usage
export const popularAreaConversions = [
  { from: 'sqmeter', to: 'sqfoot' },
  { from: 'sqfoot', to: 'sqmeter' },
  { from: 'acre', to: 'sqfoot' },
  { from: 'sqfoot', to: 'acre' },
  { from: 'sqmeter', to: 'sqyard' },
  { from: 'sqyard', to: 'sqmeter' },
  { from: 'hectare', to: 'acre' },
  { from: 'acre', to: 'hectare' },
  { from: 'sqkilometer', to: 'sqmile' },
  { from: 'sqmile', to: 'sqkilometer' },
  { from: 'sqmeter', to: 'hectare' },
  { from: 'hectare', to: 'sqmeter' },
  { from: 'sqfoot', to: 'sqinch' },
  { from: 'sqinch', to: 'sqfoot' },
  { from: 'sqmeter', to: 'sqcentimeter' },
  { from: 'sqcentimeter', to: 'sqmeter' },
  { from: 'sqyard', to: 'sqfoot' },
  { from: 'sqfoot', to: 'sqyard' },
  { from: 'acre', to: 'sqmeter' },
  { from: 'sqmeter', to: 'acre' },
  { from: 'sqkilometer', to: 'hectare' },
  { from: 'hectare', to: 'sqkilometer' },
  { from: 'sqmile', to: 'acre' },
  { from: 'acre', to: 'sqmile' },
];

// Get unit by ID
export const getUnitById = (id) => {
  return areaUnits.find(unit => unit.id === id);
};

// Convert between units
export const convertArea = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;

  // Convert to square meters first, then to target unit
  const sqMeters = value * fromUnit.factor;
  return sqMeters / toUnit.factor;
};

// Format conversion slug to readable text
export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

// Generate SEO description
export const generateSEODescription = (fromUnit, toUnit) => {
  const sampleValue = 1;
  const result = convertArea(sampleValue, fromUnit.id, toUnit.id);
  const formattedResult = result < 0.001 || result > 1000000
    ? result.toExponential(4)
    : result.toPrecision(6).replace(/\.?0+$/, '');

  return `Convert ${fromUnit.plural} to ${toUnit.plural}. 1 ${fromUnit.name} = ${formattedResult} ${toUnit.plural}. Free online area unit converter.`;
};
